<h2 mat-dialog-title>Copy from: {{data.name}}</h2>
<div>Select destination stage and list.  Whitelists will not receive any data rows, but all other lists will receive all rows</div>
<div mat-dialog-content>
  <table>
    <tr>
      <td>Analysis Stage*</td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="data.stage">
            <mat-option *ngFor="let stage of stages"
                        [value]="stage">{{stage}}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>Ruleset*</td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="data.ruleType">
            <mat-option *ngFor="let ruleType of ruleTypes"
                        [value]="ruleType">{{ruleType}}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>
  </table>
</div>

<div mat-dialog-actions>
  <button (click)="cancel()" mat-button color="primary">Cancel</button>
  <button mat-button [mat-dialog-close]="data" color="primary">Next</button>
</div>
